import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import { getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import { EcommerceOrderAssociatedChallans, EcommerceOrderSummary } from "./view-ecommerce-order.js";

export const CreateEcommerceDeliveryChallan = (props) => {
    const [warehouseProcessingDetails, setWarehouseProcessingDetails] = useState(null)
    const [ecommerceOrderDetails, setEcommerceOrderDetails] = useState(null);
    const [deliveryChallanList, setDeliveryChallanList] = useState([])
    const [mergedDeliveryChallanList, setMergedDeliveryChallanList] = useState([]);

    const [warehouseList, setWarehouseList] = useState([]);
    const [challanNumber, setChallanNumber] = useState("")
    const [selectedChallanType, setSelectedChallanType] = useState(null)
    const [internalNotes, setInternalNotes] = useState("")

    const [deliveryChallanItemArray, setDeliveryChallanItemArray] = useState([{ item_name: null, item_id: null, item_type: null, item_stock_type: null, warehouse_list: [], notes: "", notes_popover: false }])

    const [adjustStockModalShow, setAdjustStockModalShow] = useState(false)
    const [selectedItemIndex, setSelectedItemIndex] = useState(null)

    const [submitButtonState, setSubmitButtonState] = useState(false)

    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme();

    var page_name = "create-ecommerce-delivery-challan";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getOrderDetails(order_id) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-order-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "order_id": order_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body);

        if (body.operation === "success") {
            setEcommerceOrderDetails(body.data);

            return body.data.transaction_series_id
        }
    }

    async function getWarehouseProcessingDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-warehouse-processing-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "warehouse_processing_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body);
        if (body.operation === "success") {
            setWarehouseProcessingDetails(body.data);
            // setWarehouseItemArray(body.data.item_array)
            return body.data
        }
        else {
            console.log("Invalid Warehouse Processing")
            return null
        }
    }

    async function getWarehouseList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation == "success") {
            setWarehouseList(body.data);
        }
    }

    async function getDeliveryChallanByWarehouseProcessing() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecom-delivery-challan-by-warehouse-processing`, { method: 'POST', body: JSON.stringify({ "email": user.email, "warehouse_processing_id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body);
        if (body.operation === "success") {
            setDeliveryChallanList(body.data.map(obj => { return { ...obj, showDeliveryChallanDetails: false } }));
            let tc = body.data.reduce((acc, dc) => {
                dc.item_array.forEach(it => {
                    let fit = acc.find(x => x.item_id === it.item_id);
                    if (fit) {
                        it.warehouse_list.forEach(wd => {
                            let fwd = fit.warehouse_list.find(x => x.warehouse_id === wd.warehouse_id);
                            if (fwd) {
                                fwd.quantity += wd.quantity;
                                if (it.item_stock_type === "Track Serial Number") {
                                    fwd.item_data = [...fwd.item_data, ...wd.item_data]
                                }
                                else if (it.item_stock_type === "Track Batches") {
                                    wd.item_data.forEach(b => {
                                        let fb = fwd.item_data.find(x => x.uid === b.uid);
                                        if (fb) {
                                            fb.unit += b.unit;
                                        }
                                        else {
                                            fwd.item_data.push(b);
                                        }
                                    })
                                }
                            }
                            else {
                                fit.warehouse_list.push(wd);
                            }
                        })
                    }
                    else {
                        acc.push(it);
                    }
                })
                return acc;
            }, [])
            console.log("merged_challan_data", tc);
            setMergedDeliveryChallanList(tc);
        }
    }

    async function getSubSeriesData(val) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-series-data-by-name`, { method: 'POST', body: JSON.stringify({ "email": user.email, "sub_series_name": "ecommerce_delivery_challan", "transaction_series_id": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.operation == "success") {
            setChallanNumber(`${body.data.prefix_value}-${parseInt(body.data.last_count) + 1}`)
        }
        else {
            swal({
                title: "Oops",
                text: body.message,
                icon: "warning",
                buttons: {
                    confirm: {
                        text: "Go to transaction series"
                    }
                }
            }).then((val) => {
                if (val) {
                    window.open("/transaction-series")
                }
            })

            console.log("get sub series data api error")
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            getWarehouseProcessingDetails()
                .then(async (val) => {
                    if (val != null) {
                        getOrderDetails(val.order_id);
                        setChallanNumber("")
                        getSubSeriesData(val.transaction_series_id);
                        getDeliveryChallanByWarehouseProcessing();
                        getWarehouseList();

                        setstate(1);
                    }
                    else {
                        setstate(3)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setstate(3)
                })

        }
    }, [user, visibility, read, write])

    const modalValidation = () => {
        for (let j = 0; j < deliveryChallanItemArray[selectedItemIndex].warehouse_list.length; j++) {
            let warehouse_list = deliveryChallanItemArray[selectedItemIndex].warehouse_list;
            if (!warehouse_list[j].warehouse_id) {
                swal("Alert", `Select a warehouse in row - ${j + 1} of ${deliveryChallanItemArray[selectedItemIndex].item_name}`, "warning")
                return false
            }
            if (warehouse_list[j].quantity <= 0) {
                swal("Alert", `Quantity in row - ${j + 1} of ${deliveryChallanItemArray[selectedItemIndex].item_name} must be atleast 1`, "warning")
                return false
            }

            if (deliveryChallanItemArray[selectedItemIndex].item_stock_type === "Track Serial Number") {
                if (warehouse_list[j].item_data == null) {
                    swal("Alert", `Serial selection not valid in row - ${j + 1} for ${deliveryChallanItemArray[selectedItemIndex].item_name}`, "warning")
                    return false
                }
                else if (warehouse_list[j].item_data.length !== warehouse_list[j].quantity) {
                    swal("Alert", `Serial selection not valid in row - ${j + 1} for ${deliveryChallanItemArray[selectedItemIndex].item_name}`, "warning")
                    return false
                }
                else if (warehouse_list[j].item_data.map(x => x.uid).length !== new Set(warehouse_list[j].item_data.map(x => x.uid)).size) {
                    swal("Alert", `Duplicate serial selection found in row for ${deliveryChallanItemArray[selectedItemIndex].item_name}`, "warning")
                    return false
                }
            }
            else if (deliveryChallanItemArray[selectedItemIndex].item_stock_type === "Track Batches") {
                if (warehouse_list[j].item_data == null) {
                    swal("Alert", `Batch selection and quantity mismatch in row - ${j + 1} for ${deliveryChallanItemArray[selectedItemIndex].item_name}`, "warning")
                    return false
                }
                else if ((warehouse_list[j].item_data.reduce((p, o) => p + o.unit, 0) != warehouse_list[j].quantity) || warehouse_list[j].item_data.find(x => x.uid == null)) {
                    swal("Alert", `Batch selection and quantity mismatch in row - ${j + 1} for ${deliveryChallanItemArray[selectedItemIndex].item_name}`, "warning")
                    return false
                }
            }
        }

        return true
    }

    const validateDeliveryChallan = () => {
        if (!selectedChallanType) {
            swal("Alert!", "Select a Challan Type", "warning")
            return false
        }

        for (let i = 0; i < deliveryChallanItemArray.length; i++) {
            if (!deliveryChallanItemArray[i].item_id) {
                swal("Alert!", `Item not selected for row - ${i + 1}`, "warning")
                return false
            }
            if (!deliveryChallanItemArray[i].warehouse_list.length) {
                swal("Alert!", `Item Details for ${deliveryChallanItemArray[i].item_name} cannot be empty`, "warning")
                return false
            }
        }

        return true
    }

    const newDeliveryChallanSubmit = (val) => {
        var object = {}

        object.warehouse_processing_id = props.match.params.id

        object.challan_type = selectedChallanType.value
        object.internal_notes = internalNotes

        object.item_array = deliveryChallanItemArray.map(item => ({
            item_name: item.item_name,
            item_id: item.item_id,
            item_type: item.item_type,
            item_stock_type: item.item_stock_type,
            warehouse_list: item.warehouse_list,
            notes: item.notes
        }));

        object.organization_id = organization_id
        object.page_name = page_name;

        // console.log(object);
        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-ecommerce-delivery-challan`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", `Delivery Challan created as ${res.data.data.saved_ref} and saved successfully!`, "success").then((value) => { window.location.href = "/ecommerce-delivery-challan-list" });
            }
            else if (res.data.ref === 'stock_validation_error') {
                swal(res.data.message, res.data.data.map((obj, i) => `${i + 1}. ${obj.item_name} - ${obj.wid_list.map(x => warehouseList.find(y => y.wid === x).name).join(", ")}`).join("\n"), "error");
                return
            }
            else {
                swal("Oops!", res.data.message, "error");
                return
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Create Ecommerce Delivery Challan</h1>
                    </div>
                </div>
                <div>
                    {
                        state == 1 ?
                            <div className="d-flex flex-column gap-7 gap-lg-10">
                                <div className="d-flex flex-wrap flex-stack gap-5 gap-lg-10">
                                    <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#processing_form" aria-selected="true" role="tab">Process Form</a>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#order_summary" aria-selected="false" role="tab" tabIndex="-1">Order Summary</a>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#associated_challans" aria-selected="false" role="tab" tabIndex="-1">Associated Challans</a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="tab-content">

                                    <div className="tab-pane fade active show" id="processing_form" role="tab-panel">
                                        <div className="d-flex flex-column gap-7 gap-lg-10">

                                            <div className="card card-flush py-4 flex-row-fluid">
                                                <div className="card-header justify-content-start gap-5">
                                                    <div className="card-title"><h2>Basic Details</h2></div>
                                                </div>

                                                <div className="card-body pt-0">
                                                    <div className='container'>

                                                        <div className="row mb-5">
                                                            <div className="col-md-6 mb-2">
                                                                <label className="fs-5 fw-bold mb-2">Challan Number</label>
                                                                <input type="text" className="form-control form-control-solid" value={challanNumber} readOnly />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="fs-5 fw-bold mb-2">Challan Type</label>
                                                                <Select
                                                                    options={["Supply of Liquid Gas", "Job Work", "Supply on Approval", "Others"].map(x => { return { label: x, value: x } })}
                                                                    onChange={(val) => { setSelectedChallanType(val); }}
                                                                    value={selectedChallanType}
                                                                    placeholder="Select Challan Type..."
                                                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row mb-5">
                                                            <div className="col-md-12 mb-2">
                                                                <label className="fs-5 fw-bold mb-2">Internal Notes</label>
                                                                <textarea className="form-control form-control-solid" rows={3} value={internalNotes} onChange={(e) => { setInternalNotes(e.target.value) }} ></textarea>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card card-flush py-4 flex-row-fluid">
                                                <div className="card-header justify-content-start gap-5">
                                                    <div className="card-title"><h2>Items to be delivered</h2></div>
                                                </div>

                                                <div className="card-body pt-0 overflow-auto">
                                                    <div className='container min-w-700px'>

                                                        <div className="row mb-5 gx-0">
                                                            <div className="col-6"><p className="fs-5 text-center">Item</p></div>
                                                            <div className="col-2"><p className="fs-5 text-center">Quantity</p></div>
                                                            <div className="col-2"><p className="fs-5 text-center">Item details</p></div>
                                                            <div className="col-1"><p className="fs-5 text-center">Notes</p></div>
                                                            <div className="col-1"><p className="fs-5 text-center"></p></div>
                                                        </div>
                                                        {
                                                            deliveryChallanItemArray.map((obj, indx, arr) => {
                                                                return (
                                                                    <div key={indx} className="row py-2 gx-0 border-bottom align-items-center">
                                                                        <div className="col-6 my-md-0 my-2 px-1">
                                                                            <div>
                                                                                <Select
                                                                                    options={warehouseProcessingDetails.item_array.map(x => { return { label: x.item_name, value: x.item_id } })}
                                                                                    onChange={(val) => {
                                                                                        if (deliveryChallanItemArray.find(x => x.item_id == val.value)) {
                                                                                            swal("Alert!", "Duplicate item cannot be added", "warning")
                                                                                            return
                                                                                        }

                                                                                        let temp = deliveryChallanItemArray.map(a => { return { ...a } })

                                                                                        let t = warehouseProcessingDetails.item_array.find(x => x.item_id == val.value)

                                                                                        // if (t.quantity <= q) {
                                                                                        //     swal("Alert!", `Challan Dispatched for the total quantity present for ${t.item_name}`, "warning")
                                                                                        //     return
                                                                                        // }

                                                                                        temp[indx].item_name = t.item_name
                                                                                        temp[indx].item_id = t.item_id
                                                                                        temp[indx].item_type = t.item_type
                                                                                        temp[indx].item_stock_type = t.item_stock_type
                                                                                        temp[indx].warehouse_list = []
                                                                                        temp[indx].notes = ""
                                                                                        temp[indx].notes_popover = false
                                                                                        setDeliveryChallanItemArray(temp)
                                                                                    }}
                                                                                    value={obj.item_id == null ? null : { label: obj.item_name, value: obj.item_id }}
                                                                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                                                    placeholder="Select Item..."
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-2 px-1">
                                                                            <input type="number" className="form-control form-control-solid" disabled readOnly value={obj.warehouse_list.reduce((acc, curr) => acc + curr.quantity, 0).toString()} />
                                                                        </div>

                                                                        <div className="col-2 px-1 text-center">
                                                                            <button className='btn btn-success btn-sm align-self-center'
                                                                                onClick={() => {
                                                                                    if (!obj.item_id) {
                                                                                        swal("Alert!", "Please select an item", "warning")
                                                                                    } else {
                                                                                        setSelectedItemIndex(indx); setAdjustStockModalShow(true);
                                                                                    }
                                                                                }}>
                                                                                Manage
                                                                            </button>
                                                                        </div>

                                                                        <div className="col-1 p-1 text-center">
                                                                            {
                                                                                <div style={{ position: "relative", display: "inline-block" }} >

                                                                                    <button className='btn btn-info btn-sm px-4' onClick={() => {
                                                                                        let temp = deliveryChallanItemArray.map(a => { return { ...a } })
                                                                                        temp[indx].notes_popover = true
                                                                                        setDeliveryChallanItemArray(temp)
                                                                                    }}><i className="fa fa-pencil px-0" style={{ fontSize: "15px" }}></i></button>

                                                                                    <div style={{ position: "absolute", right: "0", top: "45px", boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)", backgroundColor: "#84CCCD", padding: "1rem", width: "20rem", borderRadius: "0.5rem", transition: "all 0.25s ease-in-out", zIndex: 1, opacity: deliveryChallanItemArray[indx].notes_popover ? "1" : "0", visibility: deliveryChallanItemArray[indx].notes_popover ? "visible" : "hidden" }}>
                                                                                        <textarea className="form-control form-control-solid" value={deliveryChallanItemArray[indx].notes}
                                                                                            onChange={(e) => {
                                                                                                let temp = deliveryChallanItemArray.map(a => { return { ...a } })
                                                                                                temp[indx].notes = e.target.value
                                                                                                setDeliveryChallanItemArray(temp)
                                                                                            }}
                                                                                        />

                                                                                        <button className='btn btn-sm btn-secondary px-2 py-1 mt-1'
                                                                                            onClick={() => {
                                                                                                let temp = deliveryChallanItemArray.map(a => { return { ...a } })
                                                                                                temp[indx].notes_popover = false
                                                                                                setDeliveryChallanItemArray(temp)
                                                                                            }}
                                                                                        >Close</button>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        <div className="col-1 p-1 text-center">
                                                                            <button className='btn btn-danger btn-sm' onClick={() => {
                                                                                let temp = deliveryChallanItemArray.map(a => { return { ...a } })
                                                                                temp.splice(indx, 1)
                                                                                setDeliveryChallanItemArray(temp)
                                                                            }}>✖</button>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        {
                                                            deliveryChallanItemArray.length < warehouseProcessingDetails.item_array.length &&
                                                            <div className="d-flex my-2">
                                                                <button className='btn btn-sm btn-primary' onClick={() => { setDeliveryChallanItemArray([...deliveryChallanItemArray, { item_name: null, item_id: null, item_type: null, item_stock_type: null, warehouse_list: [], notes: "", notes_popover: false }]) }}>+Add row</button>
                                                            </div>
                                                        }

                                                    </div>
                                                </div>
                                                <div className='card-footer'>
                                                    {
                                                        write &&
                                                        <button type="button" className="btn btn-lg btn-primary mt-15 mx-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { validateDeliveryChallan() && newDeliveryChallanSubmit(false) }}>
                                                            <span className="indicator-label">Save</span>
                                                            <span className="indicator-progress">Please wait...
                                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                            </span>
                                                        </button>
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="tab-pane fade" id="order_summary" role="tab-panel">
                                        <EcommerceOrderSummary ecomOrderDetails={ecommerceOrderDetails} />
                                    </div>

                                    <div className="tab-pane fade" id="associated_challans" role="tab-panel">
                                        {
                                            (deliveryChallanList.length && warehouseList.length) ?
                                                <EcommerceOrderAssociatedChallans deliveryChallanList={deliveryChallanList} warehouseList={warehouseList} />
                                                :
                                                <div className="text-gray-600 fs-3 text-center">No Delivery Challans created yet</div>
                                        }
                                    </div>

                                </div>
                            </div>
                            : state == 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Modal show={adjustStockModalShow} onHide={() => { if (modalValidation()) { setAdjustStockModalShow(false); setSelectedItemIndex(null); } }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>
                        <span className="me-2">Manage Stock</span>
                        <span className='badge badge-light-info me-2 fs-4'>{selectedItemIndex !== null && deliveryChallanItemArray.length > 0 && deliveryChallanItemArray[selectedItemIndex].item_name}</span>
                    </Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { if (modalValidation()) { setAdjustStockModalShow(false); setSelectedItemIndex(null); } }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {
                            selectedItemIndex !== null && deliveryChallanItemArray.length &&
                                deliveryChallanItemArray[selectedItemIndex].warehouse_list.length ?
                                warehouseProcessingDetails && warehouseProcessingDetails.item_array.length > 0 && warehouseList.length > 0 && deliveryChallanItemArray[selectedItemIndex].warehouse_list.map((obj, indx) => {
                                    return (
                                        <div key={indx} className="row gx-0 bg-secondary my-2 p-5 pt-10 rounded position-relative">
                                            <div className="bg-gray-500 fs-3 fw-bold h-30px position-absolute start-0 text-center top-0 w-30px" style={{ borderRadius: "20% 0 50% 0" }}>{indx + 1}</div>

                                            <div className="col-md-3 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Warehouse</label>
                                                <Select
                                                    options={warehouseProcessingDetails.item_array.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id).warehouse_list.filter(x => !deliveryChallanItemArray[selectedItemIndex].warehouse_list.find(y => y.warehouse_id === x.warehouse_id)).map((obj1) => { return { label: warehouseList.find(x => x.wid === obj1.warehouse_id).name, value: obj1.warehouse_id, branch_id: obj1.branch_id } })}
                                                    value={obj.warehouse_id === null ? null : { label: warehouseList.find((elem) => elem.wid == obj.warehouse_id).name, value: obj.warehouse_id, branch_id: obj.branch_id }}
                                                    onChange={(val) => {
                                                        let t = deliveryChallanItemArray.map(x => { return { ...x } });
                                                        t[selectedItemIndex].warehouse_list[indx].warehouse_id = val.value;
                                                        t[selectedItemIndex].warehouse_list[indx].branch_id = val.branch_id;
                                                        setDeliveryChallanItemArray(t);
                                                    }}
                                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                    placeholder="Select Warehouse..."
                                                />
                                                {!obj.warehouse_id && <span className="fs-7 text-danger">Select a Warehouse</span>}
                                            </div>
                                            <div className="col-md-2 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Quantity</label>
                                                <input className="form-control" type="number"
                                                    onChange={(e) => {
                                                        if (!obj.warehouse_id) {
                                                            swal("Alert!", "Select a Warehouse", "warning")
                                                            return
                                                        }

                                                        let t1 = e.target.value == "" ? 0 : parseInt(e.target.value);

                                                        if (t1 < 0) {
                                                            swal("Alert!", "Negative quantity not allowed", "warning")
                                                            return
                                                        }

                                                        // current warehouse proccessing quantity
                                                        let a = warehouseProcessingDetails.item_array.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id).warehouse_list.find(x => x.warehouse_id === obj.warehouse_id).quantity

                                                        // total of all quantities of that item and of that warehouse from all previous challans
                                                        let b = mergedDeliveryChallanList.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id)?.warehouse_list.find(x => x.warehouse_id === obj.warehouse_id)?.quantity || 0

                                                        if (t1 > a - b) {
                                                            swal("Alert!", `Maximum quantity reached`, "warning")
                                                            return
                                                        }

                                                        let t = deliveryChallanItemArray.map(x => { return { ...x } });
                                                        t[selectedItemIndex].warehouse_list[indx].quantity = t1
                                                        setDeliveryChallanItemArray(t);
                                                    }}
                                                    value={obj.quantity}
                                                />
                                                {obj.quantity <= 0 && <span className="fs-7 text-danger">Quantity must be atleast 1</span>}
                                            </div>

                                            <div className="col-md-7 px-1 mb-2">
                                                {
                                                    deliveryChallanItemArray[selectedItemIndex].item_stock_type === "Track Serial Number" ?
                                                        <>
                                                            <label className="required fs-5 fw-bold mb-2">Serial</label>
                                                            <Select
                                                                options={obj.warehouse_id === null ? [] : warehouseProcessingDetails.item_array.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id).warehouse_list.find(y => y.warehouse_id === obj.warehouse_id).item_data.map((obj1) => { return { label: obj1.serial_name, value: obj1.uid } })}
                                                                onChange={(val) => {
                                                                    if (val.length > obj.quantity) {
                                                                        swal("Alert!", "Maximum quantity reached", "warning")
                                                                        return
                                                                    }

                                                                    let o = obj.item_data || []
                                                                    if (val.length > o.length) {
                                                                        // previously challaned serial list from all previous challans of that item of that warehouse
                                                                        let b = mergedDeliveryChallanList.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id)?.warehouse_list.find(x => x.warehouse_id === obj.warehouse_id)?.item_data || []
                                                                        let new_serial = val.find(x => !o.find(y => y.uid === x.value))

                                                                        if (b.find(x => x.uid === new_serial.value)) {
                                                                            swal("Alert!", "This serial has already been challaned", "warning")
                                                                            return
                                                                        }
                                                                    }

                                                                    let t = deliveryChallanItemArray.map(x => { return { ...x } });
                                                                    t[selectedItemIndex].warehouse_list[indx].item_data = val.length == 0 ? null : val.map(x => { return { serial_name: x.label, uid: x.value } })
                                                                    setDeliveryChallanItemArray(t);
                                                                }}
                                                                value={obj.item_data == null ? [] : obj.item_data.map(x => { return { label: x.serial_name, value: x.uid } })}
                                                                isMulti
                                                                styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                                placeholder="Select Serial Numbers..."
                                                            />
                                                            {(!obj.item_data || obj.quantity !== obj.item_data.length) && <span className="fs-7 text-danger">Serial Count and Quantity mismatch</span>}
                                                        </>
                                                        :
                                                        deliveryChallanItemArray[selectedItemIndex].item_stock_type === "Track Batches" ?
                                                            <>
                                                                <label className="required fs-5 fw-bold mb-2">Batch</label>
                                                                <div>
                                                                    {
                                                                        obj.item_data && obj.item_data.map((batch, i) => {

                                                                            return (
                                                                                <div className='d-flex align-items-center gap-1 my-1' key={i}>
                                                                                    <div style={{ flex: "5" }}>
                                                                                        <Select
                                                                                            options={obj.warehouse_id === null ? [] : warehouseProcessingDetails.item_array.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id).warehouse_list.find(y => y.warehouse_id === obj.warehouse_id).item_data.map((obj1) => { return { label: obj1.batch_reference, value: obj1.uid } })}
                                                                                            onChange={(val) => {
                                                                                                if (obj.item_data.find(x => x.uid == val.value) !== undefined) {
                                                                                                    swal("Alert!", "Duplicate batch cannot be selected", "warning")
                                                                                                    return
                                                                                                }

                                                                                                // current warehouse processing unit for selected batch of this item of this warehouse
                                                                                                let a = warehouseProcessingDetails.item_array.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id).warehouse_list.find(x => x.warehouse_id === obj.warehouse_id).item_data.find(x => x.uid === val.value).unit

                                                                                                // total of all units of selected batch of this item of this warehouse from all previous challans
                                                                                                let b = mergedDeliveryChallanList.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id)?.warehouse_list.find(x => x.warehouse_id === obj.warehouse_id)?.item_data.find(x => x.uid === val.value)?.unit || 0

                                                                                                if (a - b <= 0) {
                                                                                                    swal("Alert!", "This Batch cannot be selected as all of its units has already been challaned", "warning");
                                                                                                    return
                                                                                                }

                                                                                                let temp = deliveryChallanItemArray.map(a => { return { ...a } })
                                                                                                temp[selectedItemIndex].warehouse_list[indx].item_data[i] = { batch_reference: val.label, uid: val.value, unit: 0 }
                                                                                                setDeliveryChallanItemArray(temp)
                                                                                            }}
                                                                                            value={(batch.uid === null) ? null : { label: batch.batch_reference, value: batch.uid }}
                                                                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                                                            placeholder="Select Batches..."
                                                                                        />
                                                                                    </div>
                                                                                    <div style={{ flex: "2" }}>
                                                                                        <input type="number" className="form-control form-control-solid px-1" value={batch.unit.toString()}
                                                                                            disabled={!batch.uid}
                                                                                            onChange={(e) => {
                                                                                                let t1 = e.target.value == "" ? 0 : parseInt(e.target.value);

                                                                                                if (t1 < 0) {
                                                                                                    swal("Alert!", "Negative unit not allowed", "warning")
                                                                                                    return
                                                                                                }

                                                                                                // current warehouse processing unit for selected batch of this item of this warehouse
                                                                                                let a = warehouseProcessingDetails.item_array.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id).warehouse_list.find(x => x.warehouse_id === obj.warehouse_id).item_data.find(x => x.uid === batch.uid).unit

                                                                                                // total of all units of selected batch of this item of this warehouse from all previous challans
                                                                                                let b = mergedDeliveryChallanList.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id)?.warehouse_list.find(x => x.warehouse_id === obj.warehouse_id)?.item_data.find(x => x.uid === batch.uid)?.unit || 0

                                                                                                if (t1 > a - b) {
                                                                                                    swal("Alert!", `Maximum unit (${a - b}) reached for batch - ${batch.batch_reference}`, "warning");
                                                                                                    return
                                                                                                }

                                                                                                let temp = deliveryChallanItemArray.map(a => { return { ...a } })
                                                                                                temp[selectedItemIndex].warehouse_list[indx].item_data[i] = { ...temp[selectedItemIndex].warehouse_list[indx].item_data[i], unit: t1 }
                                                                                                setDeliveryChallanItemArray(temp)
                                                                                            }}
                                                                                        />
                                                                                    </div>

                                                                                    <button className='btn btn-link btn-sm text-hover-danger' style={{ flex: "1" }} onClick={() => {
                                                                                        let temp = deliveryChallanItemArray.map(a => ({ ...a }));
                                                                                        temp[selectedItemIndex].warehouse_list[indx].item_data.splice(i, 1);
                                                                                        temp[selectedItemIndex].warehouse_list[indx].item_data = temp[selectedItemIndex].warehouse_list[indx].item_data.length === 0 ? null : temp[selectedItemIndex].warehouse_list[indx].item_data;
                                                                                        setDeliveryChallanItemArray(temp);
                                                                                    }}>✖</button>

                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                    <button
                                                                        className='btn p-0 text-hover-primary'
                                                                        onClick={() => {
                                                                            let temp = deliveryChallanItemArray.map(a => ({ ...a }));
                                                                            if (temp[selectedItemIndex].warehouse_list[indx].item_data) {
                                                                                temp[selectedItemIndex].warehouse_list[indx].item_data.push({ batch_reference: null, uid: null, unit: 0 });
                                                                            } else {
                                                                                temp[selectedItemIndex].warehouse_list[indx].item_data = [{ batch_reference: null, uid: null, unit: 0 }];
                                                                            }
                                                                            setDeliveryChallanItemArray(temp);
                                                                        }}><i className="bi bi-plus-circle"></i> Add Batch
                                                                    </button>
                                                                </div>
                                                                {(!obj.item_data || obj.quantity !== obj.item_data.reduce((p, o) => p + o.unit, 0)) && <><span className="fs-7 text-danger">Batch Unit Count and Quantity mismatch</span><br /></>}
                                                                {(!obj.item_data || obj.item_data.find(x => x.uid === null)) && <span className="fs-7 text-danger">Select Batches properly</span>}
                                                            </>
                                                            :
                                                            <div className='text-gray-600 fs-4 text-center pt-md-10'>No data required for this item</div>
                                                }
                                            </div>

                                            <div
                                                className="bg-danger fs-3 fw-bold h-30px position-absolute end-0 text-center top-0 w-30px cursor-pointer"
                                                style={{ borderRadius: "0 20% 0 50%" }}
                                                onClick={() => {
                                                    let t = deliveryChallanItemArray.map(x => { return { ...x } });
                                                    t[selectedItemIndex].warehouse_list.splice(indx, 1);
                                                    setDeliveryChallanItemArray(t);
                                                }}
                                            >✖</div>

                                        </div>
                                    )
                                })
                                :
                                <div className="text-center fs-2 text-gray-600">No Warehouse Added</div>

                        }
                        {selectedItemIndex !== null && warehouseProcessingDetails && deliveryChallanItemArray[selectedItemIndex].warehouse_list.length < warehouseProcessingDetails.item_array.find(x => x.item_id === deliveryChallanItemArray[selectedItemIndex].item_id).warehouse_list.length &&
                            <button className='btn btn-primary btn-sm m-3'
                                onClick={() => {
                                    let t = deliveryChallanItemArray.map(x => { return { ...x } });
                                    t[selectedItemIndex].warehouse_list.push({ warehouse_id: null, branch_id: null, quantity: 0, item_data: null });
                                    setDeliveryChallanItemArray(t);
                                }}>+ Add Warehouse</button>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { if (modalValidation()) { setAdjustStockModalShow(false); setSelectedItemIndex(null); } }}>Close</button>
                </Modal.Footer>
            </Modal>
        </>);

};

export default CreateEcommerceDeliveryChallan;
